import '../scss/app.scss';

console.log('child theme loaded')